import { createFromIconfontCN } from '@ant-design/icons';

/* 采用iconfont Symbol模式
每次更新icon后，记得复制最新的地址哦～ */

const Icon = createFromIconfontCN({
  scriptUrl: [
    '//at.alicdn.com/t/font_2629103_setg68gkluq.js',
    '//at.alicdn.com/t/font_2581020_dqan4232fbc.js',
    // 订单优化
    '//at.alicdn.com/t/font_3051549_p1sb7oua629.js',
    '//at.alicdn.com/t/c/font_3705962_6aqaad9tl0q.js',
    // 素材管理平台更新的icon库——管理员（盘小古）
    '//at.alicdn.com/t/c/font_3705962_vk8dytftepm.js',
  ]
});;

export default Icon;
